import React from 'react'
import building from './images/building.jpg'
import './About.css'

const About = () => {
    return (
        <div className='about' id='about'>
            <div className='container'>
                <img id="building"src={building} alt='john' />
                <div className='col-2'>
                    <h2>About</h2>
                    <span className='line'></span>
                    <p>Welcome to <b>BSJ Real Estate</b>, where your dream home becomes a reality. <b>Since 2002</b>, we have proudly served our community for over two decades, earning the trust and satisfaction of countless happy customers.</p>
                    <p>at <u>BSJ Real Estate</u>, we believe that finding the perfect home is just the beginning. Our commitment to excellence extends beyond the sale, with unparalleled after-support that ensures your peace of mind long after you've settled in.</p>
                </div>
            </div>
        </div>
    )
}

export default About
